import PropTypes from 'prop-types';
import React from 'react';

const VerifyEmail = ({
  isFetching,
  successMessage,
  errorMessage,
}) => (
  <div className="u-text-center">
    <h2 className="c-heading u-mv+">Verify email</h2>
    { isFetching ?
      <div className="c-heading--large">Verifying email... Please wait...</div>
    :
      <div className="c-heading--large">
        {successMessage || errorMessage}
      </div>
    }
  </div>
);
VerifyEmail.propTypes = {
  isFetching: PropTypes.bool,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
};
VerifyEmail.defaultProps = {
  isFetching: false,
  successMessage: '',
  errorMessage: '',
};

export default VerifyEmail;




// WEBPACK FOOTER //
// ./src/app/confirmation/components/VerifyEmail.jsx